export const isIOS = (): boolean => {
  if (typeof navigator === 'undefined') {
    return false;
  }

  if (/iPhone|iPod/.test(navigator.userAgent)) {
    return true;
  }

  return /Mac/.test(navigator.userAgent) && navigator.maxTouchPoints > 1;
};

export const isAndroid = (): boolean => {
  if (typeof navigator === 'undefined') {
    return false;
  }

  return /Android/i.test(navigator.userAgent);
};

export const isMobileDevice = (): boolean => {
  if (typeof navigator === 'undefined') {
    return false;
  }

  const uaData = (navigator as Navigator & {
    userAgentData?: { mobile?: boolean };
  }).userAgentData;

  if (typeof uaData?.mobile === 'boolean') {
    return uaData.mobile;
  }

  return isIOS() || isAndroid();
};
